<template>
    <div class="recycle" v-if="isMounted" v-can="'recycle_leads.access'">
        <ds-filter
            ssr
            :default-date="date"
            :fields="fields"
            :data="filtersData"
            :loaded="loader"
            :disabled="filterDisabled"
            @submit="submitFilter"
            @resetFilter="refreshFilter"
        >
            <vs-col
                vs-w="12"
                vs-sm="6"
                vs-lg="3"
                vs-xs="12"
            >
                <div class="m-2">
                    <label class="text-sm opacity-75">{{ $t('global.Send_date') }}</label>
                    <date-picker
                        @select="selectedDate"
                        :date="date.send_date"
                        direction="send_date"
                        :disabled="filterDisabled"
                    />
                </div>
            </vs-col>

            <vs-col
                vs-w="12"
                vs-sm="6"
                vs-lg="3"
                vs-xs="12"
            >
                <div class="m-2">
                    <vs-checkbox
                        class="mb-4"
                        v-model="non_ftd"
                        :disabled="filterDisabled"
                    >NON FTD</vs-checkbox>
                </div>
            </vs-col>

            <template v-slot:footer>
                <vs-button
                    v-can="'recycle_leads.create'"
                    @click="recycleAction"
                    :disabled="recycleDisabled || !leads.length || loader || statusSystem !== 'leads'"
                    color="primary"
                    type="filled"
                >Recycle</vs-button>
            </template>

            <template #actions>
                <div class="p-3 cursor-pointer" @click="autoRecycle()" v-tooltip="$t('global.automation')">
                    <vs-icon v-bind="$iconData('icon-zap', 'fi-rr-bolt')" />
                </div>
            </template>
        </ds-filter>

        <tabs
            :tabs="statusList"
            translate
            panel
            :active-tab="activeTab"
            :loaded="loader"
            @selected="selectedTab"
        >
            <template v-slot:panel>
                <div class="flex items-center pr-2">
                    <div v-if="statusSystem === 'pending' && leads.length  && isPermission('recycle_leads.create')" class="flex item-center">
                        <vs-button
                            class="mr-2"
                            radius
                            :disabled="!selectIds.length && selectAll"
                            type="flat"
                            v-bind="$iconData('icon-trash-2', 'fi-rr-trash')"
                            @click="clearQueue"
                        ></vs-button>

                        <vs-button
                            v-if="selectAll"
                            class="mr-2"
                            radius
                            color="danger"
                            type="flat"
                            v-bind="$iconData('icon-x', 'fi-rr-cross-small')"
                            @click="clearQueueClose"
                        ></vs-button>
                    </div>

                    <div v-if="statusSystem === 'failed' && isPermission('recycle_leads.create')">
                        <vs-button
                            :disabled="!leads.length"
                            v-tooltip="$t('tooltip.clearErrors')"
                            class="mr-2"
                            radius
                            type="flat"
                            v-bind="$iconData('icon-trash-2', 'fi-rr-trash')"
                            @click="clearErrors"
                        ></vs-button>
                    </div>

                    <div>
                        <vs-button
                            :disabled="loader"
                            v-tooltip="$t('tooltip.Refresh_table')"
                            class="mr-2"
                            radius
                            type="flat"
                            v-bind="$iconData('icon-rotate-cw', 'fi-rr-rotate-right')"
                            @click="refreshTable"
                        ></vs-button>
                    </div>

                    <vs-dropdown
                        ref="dropdown"
                        class="cursor-pointer mr-2"
                        vs-custom-content vs-trigger-click
                    >
                        <a class="flex items-center cursor-pointer" href.prevent>
                            <feather-icon class="mr-1" icon="SlidersIcon" svgClasses="h-4 w-4 ml-1"/>
                            <span>{{ $t('global.view') }}</span>
                        </a>

                        <vs-dropdown-menu class="leads_dropdown">
                            <ul>
                                <li class="flex items-center"
                                    v-for="(display, index) of heads"
                                    :key="index"
                                    v-if="display.value !== 'checkbox'"
                                >
                                    <vs-button
                                        radius color="primary"
                                        type="flat"
                                        v-bind="$iconData(display.display ? 'icon-eye' : 'icon-eye-off', display.display ? 'fi-rr-eye' : 'fi-rr-eye-crossed')"
                                        @click="view(display)"
                                    ></vs-button>
                                    <span class="ml-2 mr-4 whitespace-no-wrap">{{ $t(display.name) }}</span>
                                </li>
                            </ul>
                        </vs-dropdown-menu>
                    </vs-dropdown>

                    <div v-if="statusSystem === 'sent'">
                        <vs-button
                          v-can="'statistic_lead.download_leads'"
                          class="mr-2"
                          v-tooltip="$t('tooltip.Download_CSV')"
                          radius
                          type="flat"
                          v-bind="$iconData('icon-download', 'fi-rr-download')"
                          @click="downloadCSV"
                        ></vs-button>
                    </div>
                </div>
            </template>

            <ds-table
                ref="table"
                :data="leads"
                :heads="heads"
                ssr
                spacer
                :select="statusSystem === 'pending' && selectAll"
                select-key="id"
                @selected="selectedLead"
                :view-items="[50, 100, 500]"
                :total="totalNum"
                :max-items="limitNum"
                :page="pageNum"
                :disabled="loader"
                @page="page"
                @limit="limit"
                @sort="sort"
            >
                <template v-slot:person="{person}">
                    <div>
                        <div class="whitespace-no-wrap flex items-center">
                            <vs-icon class="mr-1" color="primary" v-bind="$iconData('icon-user', 'fi-rr-user')"></vs-icon>
                            {{ person.first_name ? person.first_name : '-' }} {{ person.last_name ? person.last_name : '-' }}
                        </div>
                        <div class="whitespace-no-wrap flex items-center">
                            <vs-icon class="mr-1" color="primary" v-bind="$iconData('icon-mail', 'fi-rr-envelope')"></vs-icon>
                            {{ person.email ? person.email : '-' }}
                        </div>
                        <div class="whitespace-no-wrap flex items-center">
                            <vs-icon class="mr-1" color="primary" v-bind="$iconData('icon-smartphone', 'fi-rr-mobile-notch')"></vs-icon>
                            {{ person.phone ? person.phone : '-' }}
                        </div>
                    </div>
                </template>

                <template v-slot:guarantee="{guarantee}">
                    <div class="text-center">
                        <vs-icon v-if="guarantee.guarantee" color="success" v-bind="$iconData('icon-check', 'fi-rr-check')"></vs-icon>
                        <vs-icon v-else color="danger" v-bind="$iconData('icon-x', 'fi-rr-cross-small')"></vs-icon>
                    </div>
                </template>

                <template v-slot:country="{country}">
                    <div v-if="country.country && country.country !== undefined && country.country !== 'undefined'"
                         class="flex items-center">
                        <flag width="25" :iso="country.country" type="country"/>
                        <span class="pl-2">{{ country.country }}</span>
                    </div>
                    <div v-else>-</div>
                </template>

                <template v-slot:language="{language}">
                    <div v-if="language.language && language.language !== undefined && language.language !== 'undefined'"
                         class="flex items-center">
                        <flag width="25" :iso="language.language" type="language"/>
                        <span class="pl-2">{{ language.language }}</span>
                    </div>
                    <div v-else>-</div>
                </template>

                <template v-slot:geo="{geo}">
                    <div v-if="geo.geo && geo.language !== undefined && geo.geo !== 'undefined'" class="flex items-center">
                        <img style="width: 25px" :src="getGeoFlag(geo.geo).flag" alt="">
                        <span class="pl-2 whitespace-no-wrap">{{ geo.geo }}</span>
                    </div>
                    <div v-else>-</div>
                </template>

                <template v-slot:advertiser="{advertiser}">
                    <div class="whitespace-no-wrap">{{ advertiser.advertiser || advertiser.advertiser_id || '-' }} /
                        {{ advertiser.integration ? advertiser.integration.name : '-' }}
                    </div>
                </template>

                <template v-slot:status="{status}">
                    <div class="flex justify-center">
                        <div v-if="!status.status">-</div>
                        <vs-chip v-else transparent :color="statusColor(status.status)">
                            <span class="whitespace-no-wrap">{{ createName(status.status) }}</span>
                        </vs-chip>
                    </div>
                </template>

                <template v-slot:team="{team}">
                    <div class="flex items-center whitespace-no-wrap">
                        <vs-icon color="primary" v-bind="$iconData('icon-users', 'fi-rr-users')"></vs-icon>
                        <div class="ml-2 whitespace-no-wrap">{{ team.team ? (team.team.name || team.team.id) : '-' }}</div>
                    </div>
                </template>


                <template v-slot:affiliate="{affiliate}">
                    <div class="whitespace-no-wrap">{{ affiliate.user ? (affiliate.user.name || affiliate.user.id) : '-' }}</div>
                </template>

                <template v-slot:sms="{sms}">
                    <div v-if="!sms.sms_error && !sms.sms_status && !sms.sms_text">-</div>
                    <div v-else>
                        <p>{{ sms.sms_error }}</p>
                        <p>{{ sms.sms_status }}</p>
                        <p>{{ sms.sms_text }}</p>
                    </div>
                </template>

                <template v-slot:eValidation="{eValidation}">
                    <div v-if="eValidation.errors_validation && Object.keys(eValidation.errors_validation).length">
                        <div class="flex items-center" v-for="(value, key) in eValidation.errors_validation" :key="key">
                            <vs-icon v-bind="$iconData('icon-alert-circle', 'fi-rr-circle-exclamation-check')" color="red"></vs-icon>
                            <div class="whitespace-no-wrap ml-2" v-for="(v, ind) of value" :key="ind">{{ v }}</div>
                        </div>
                    </div>
                    <div v-else>-</div>
                </template>

                <template v-slot:a_history="{a_history}">
                    <div v-if="a_history.advertisers_history">
                        <div class="flex items-center" v-if="value" v-for="(value, key) in a_history.advertisers_history"
                             :key="key">
                            <vs-icon v-bind="$iconData('icon-alert-circle', 'fi-rr-circle-exclamation-check')" color="red"></vs-icon>
                            <div class="whitespace-no-wrap ml-2">{{ value }}</div>
                        </div>
                    </div>
                    <div v-else>-</div>
                </template>

                <template v-slot:errorStatus="{errorStatus}">
                    <div v-if="errorStatus.advertiser_response" class="flex items-center">
                        <vs-icon v-bind="$iconData('icon-alert-circle', 'fi-rr-circle-exclamation-check')" color="red"></vs-icon>
                        <div>
                            <div class="whitespace-no-wrap ml-2 textOverflow statusErrorsText">{{ errorStatus.advertiser_response }}</div>
                        </div>
                        <vs-icon
                            class="ml-2 cursor-pointer"
                            color="primary"
                            v-tooltip="$t('tooltip.Copy')"
                            @click.stop.prevent="copy(errorStatus.advertiser_response)"
                            v-bind="$iconData('icon-icon-copy', 'fi-rr-copy-alt')"
                        />
                        <vs-icon
                            v-if="errorStatus.advertiser_response && errorStatus.advertiser_response.length >= 35"
                            class="ml-2 cursor-pointer"
                            color="primary"
                            @click.stop.prevent="errorStatusInfo(errorStatus.advertiser_response)"
                            v-bind="$iconData('icon-eye', 'fi-rr-eye')"
                        />

                    </div>
                    <div v-else>-</div>
                </template>

                <template v-slot:created_at="{created_at}">
                    <div v-if="!created_at.created_at">-</div>
                    <div v-else>
                        <div class="whitespace-no-wrap flex items-center">
                            <vs-icon class="mr-1" color="primary" v-bind="$iconData('icon-calendar', 'fi-rr-calendar-day')"></vs-icon>
                            <span v-if="created_at.created_at">{{ created_at.created_at|date }}</span>
                        </div>
                        <div class="whitespace-no-wrap flex items-center">
                            <vs-icon class="mr-1" color="primary" v-bind="$iconData('icon-clock', 'fi-rr-clock-three')"></vs-icon>
                            <span v-if="created_at.created_at">{{ created_at.created_at|time }}</span>
                        </div>
                    </div>
                </template>

                <template v-slot:send_date="{send_date}">
                    <div v-if="!send_date.send_date">-</div>
                    <div v-else>
                        <div class="whitespace-no-wrap flex items-center">
                            <vs-icon class="mr-1" color="primary" v-bind="$iconData('icon-calendar', 'fi-rr-calendar-day')"></vs-icon>
                            <span v-if="send_date.send_date">{{ send_date.send_date|date }}</span>
                        </div>
                        <div class="whitespace-no-wrap flex items-center">
                            <vs-icon class="mr-1" color="primary" v-bind="$iconData('icon-clock', 'fi-rr-clock-three')"></vs-icon>
                            <span v-if="send_date.send_date">{{ send_date.send_date|time }}</span>
                        </div>
                    </div>
                </template>

                <template v-slot:first_action_date="{first_action_date}">
                    <div class="flex items-center">
                        <div>
                            <div v-if="!first_action_date.first_action_date">-</div>
                            <div v-else>
                                <div class="whitespace-no-wrap flex items-center">
                                    <vs-icon class="mr-1" color="primary" v-bind="$iconData('icon-calendar', 'fi-rr-calendar-day')"></vs-icon>
                                    <span v-if="first_action_date.first_action_date">{{first_action_date.first_action_date|date}}</span>
                                </div>
                                <div class="whitespace-no-wrap flex items-center">
                                    <vs-icon class="mr-1" color="primary" v-bind="$iconData('icon-clock', 'fi-rr-clock-three')"></vs-icon>
                                    <span v-if="first_action_date.first_action_date">{{first_action_date.first_action_date|time}}</span>
                                </div>
                            </div>
                        </div>

                        <div v-can="'recycle_leads.fix'" class="ml-4" v-if="first_action_date.first_action_date && status === 'sent'">
                            <vs-button
                                :disabled="first_action_date.is_fixed_lead"
                                size="small"
                                color="primary"
                                type="filled"
                                @click="fixDeposit(first_action_date.id)"
                            >Fix</vs-button>
                        </div>
                    </div>
                </template>

                <template v-slot:landing="{landing}">
                    <v-text v-if="landing.landing_url" :text="landingUrl(landing.landing_url)"></v-text>

                    <div v-else>-</div>
                </template>
            </ds-table>
        </tabs>
    </div>
</template>

<script>
import ErrorHandler from "@/utils/errorHandler"
import send from "@/utils/fetch"
import {dateParse} from '@/utils/mixins'
import {checkPermission} from '@/utils/mixins'
import EventBus from "@/store/eventBus"
import {getLanguages, copy, download} from "@/utils/utils"
import VText from "@/components/Text.vue";

export default {
    components: {VText},
    mixins: [
        dateParse,
        checkPermission
    ],

    data() {
        return {
            isMounted: false,
            loader: false,
            filterDisabled: false,
            recycleDisabled: true,
            isClearQueue: false,
            fields: [
                {name: 'modals.Phone', type: 'input', label: 'phone', field: 'phone'},
                {name: 'statistic_fields.id', type: 'input', label: 'id', field: 'id'},
                {name: 'statistic_fields.lead_id', type: 'input', label: 'lead_id', field: 'lead_id', display: false},
                {name: 'table_filters.advertiser_id', type: 'select', label: 'advertiser_id', field: 'advertiser_id', multiple: true},
                {name: 'table_filters.advertiser_integration_id', type: 'select', label: 'advertiser_integration_id', field: 'advertiser_integration_id', multiple: true},
                {name: 'table_filters.traffic_model_id', type: 'select', label: 'traffic_model_id', field: 'traffic_model_id', multiple: true},
                {name: 'table_filters.team_id', type: 'select', label: 'team_id', field: 'team_id', multiple: true},
                {name: 'table_filters.affiliate_id', type: 'select', label: 'affiliate_id', field: 'affiliate_id', multiple: true},
                {name: 'table_filters.group_status', type: 'select', label: 'group_status', field: 'group_status', multiple: true},
                {name: 'table_filters.landing_name', type: 'select', label: 'landing_name', field: 'landing_name', multiple: true},
                {name: 'table_filters.geo', type: 'select', label: 'geo', field: 'geo', multiple: true},
                {name: 'table_filters.domain', type: 'select', label: 'domain', field: 'domain'},
                {name: 'table_filters.guarantee', type: 'select', label: 'guarantee', field: 'guarantee', can: 'statistic_lead.guarantee'},

                {name: 'table_filters.language', type: 'select', label: 'language', field: 'language', required: true, footer: true},
                {name: 'table_filters.country', type: 'select', label: 'country', field: 'country', required: true, footer: true},
                {name: 'table_filters.offer_name', type: 'select', label: 'offer_name', field: 'offer_name', required: true, footer: true},
            ],
            headsSystem: [
                {name: 'statistic_fields.id', key: 'id', sortKey: 'id', value: 'id', display: true},
                {name: 'statistic_fields.lead_id', key: 'lead_id', sortKey: 'lead_id', value: 'lead_id', display: true},
                {name: 'statistic.guarantee', key: 'guarantee', sortKey: 'guarantee', value: 'guarantee', display: true, can: 'statistic_lead.guarantee'},
                {name: 'global.Lead', key: 'person', sortKey: 'first_name', value: 'person', display: true},
                {name: 'global.Country', key: 'country', sortKey: 'country', value: 'country', display: true},
                {name: 'statistic.Lang', key: 'language', sortKey: 'language', value: 'language', display: true},
                {name: 'global.Geo', key: 'geo', sortKey: 'geo',  value: 'geo', display: true},
                {name: 'global.Offer', key: 'offer_name', sortKey: 'offer_name', value: 'offer_name', display: true},
                {name: 'global.Landing', key: 'landing_name', sortKey: 'landing_name', value: 'landing_name', display: true},
                {name: 'global.Domain', key: 'landing_url', sortKey: 'landing_url', value: 'landing', display: true},
                {name: 'global.Team', key: 'team', sortKey: 'team_name', value: 'team', display: true},
                {name: 'global.Affiliate', key: 'affiliate_hash', sortKey: 'affiliate_name', value: 'affiliate', display: true},
                {name: 'statistic_fields.sub1', key: 'sub1', sortKey: 'sub1', value: 'sub1', display: true},
                {name: 'statistic_fields.sub2', key: 'sub2', sortKey: 'sub2', value: 'sub2', display: true},
                {name: 'statistic_fields.sub3', key: 'sub3', sortKey: 'sub3', value: 'sub3', display: true},
                {name: 'statistic_fields.sub4', key: 'sub4', sortKey: 'sub4', value: 'sub4', display: true},
                {name: 'statistic_fields.sub5', key: 'sub5', sortKey: 'sub5', value: 'sub5', display: true},
                {name: 'statistic_fields.sub6', key: 'sub6', sortKey: 'sub6', value: 'sub6', display: true},
                {name: 'statistic_fields.sub7', key: 'sub7', sortKey: 'sub7', value: 'sub7', display: true},
                {name: 'statistic_fields.sub8', key: 'sub8', sortKey: 'sub8', value: 'sub8', display: true},
                {name: 'statistic_fields.sub9', key: 'sub9', sortKey: 'sub9', value: 'sub9', display: true},
                {name: 'statistic_fields.sms', key: 'sms_status', value: 'sms', display: true},
                {name: 'statistic.ADV_INT', key: 'advertiser_integration_id', sortKey: 'advertiser', value: 'advertiser', display: true},
                {name: 'statistic.SYS_Status', key: 'status', sortKey: 'status', value: 'status', display: true},
                {name: 'statistic.ERR_Status', key: 'advertiser_response', sortKey: 'advertiser_response', value: 'errorStatus', display: true},
                {name: 'statistic.Validation_errors', key: 'errors_validation', sortKey: 'errors_validation', value: 'eValidation', display: true},
                {name: 'global.ADV_history', key: 'advertisers_history', value: 'a_history', display: true},
                {name: 'statistic.ADV_Status', key: 'group_status', sortKey: 'group_status', value: 'group_status', display: true},
                {name: 'statistic.Reg_date', key: 'created_at', sortKey: 'created_at', value: 'created_at', display: true},
                {name: 'global.Send_date', key: 'send_date', sortKey: 'send_date', value: 'send_date', display: true},
                {name: 'global.Action_date', key: 'first_action_date', sortKey: 'first_action_date', value: 'first_action_date', display: true},
            ],
            heads: [],
            date: {
                created_at: {startDate: new Date(), endDate: new Date()},
                send_date: {startDate: new Date(), endDate: new Date()},
                first_action_date: {startDate: new Date(), endDate: new Date()},
            },
            filtersData: {},
            leads: [],
            pageNum: 1,
            limitNum: 50,
            totalNum: 1,
            status: 'leads',
            statusSystem: 'leads',
            activeTab: 0,
            statusList: [],
            non_ftd: false,
            orderBy: {"name": "id", "direction": "desc"},
            selectDateSystem: {
                start: this.dateParse(new Date()),
                end: this.dateParse(new Date()),
                direction: 'send_date'
            },
            selectDate: {
                start: this.dateParse(new Date()),
                end: this.dateParse(new Date()),
                direction: 'send_date'
            },
            filter: {},
            templateSendTab: {
                leads: {
                    path: this.$url.recycle.leads,
                    filter: this.$url.recycle.leads_filter
                },
                pending: {
                    path: this.$url.recycle.pending
                },
                sent: {
                    path: this.$url.recycle.sent,
                    filter: this.$url.recycle.sent_filter,
                },
                failed: {
                    path: this.$url.recycle.failed
                }
            },
            selectedRequiredData: [
                'country',
                'language',
                'offer_name'
            ],
            selectedRequiredDataTransform: {
                'country': 'country',
                'language': 'language',
                'offer_name': 'offer'
            },
            selectIds: [],
            selectAll: false
        }
    },

    computed: {
        isAdv() {
            return this.userState.group === 2 ||
                this.userState.team.is_internal ||
                this.isPermission('statistic_lead.advertiser')
        },

        userState() {
            return this.$store.getters.userState
        }
    },

    watch: {
        '$i18n.locale'() {
            if (this.filtersData.guarantee && this.filtersData.guarantee.length) {
                this.filtersData.guarantee = this.guaranteeLocale(this.filtersData.guarantee)
            }
        },
    },

    methods: {
        selectedLead(ids) {
            this.selectIds = ids
        },

        autoRecycle() {
            EventBus.$emit('emitPopupEvent', {type: 'automation', name: this.$t('global.automation'), data: {}, full: true})
        },

        errorStatusInfo(data) {
            EventBus.$emit('emitPopupEvent', {type: 'errorStatusInfo', name: this.$t('statistic.ERR_Status'), data: data})
        },

        async downloadCSV() {
            let columns = this.heads
                .filter(column => column.display === true)
                .map((column) => {
                    switch (column.value) {
                    case 'landing':
                        return 'landing_name'
                    case 'team':
                        return 'team_name'
                    case 'affiliate':
                        return 'affiliate_name'
                    case 'sms':
                        return 'sms_count'
                    case 'advertiser':
                        return 'advertiser_name'
                    case 'eValidation':
                        return 'errors_validation'
                    case 'a_history':
                        return 'advertisers_history'
                    case 'errorStatus':
                        return 'advertiser_response'
                    default:
                        return column.value
                    }
                })

            if(columns.includes('person')) {
                columns = columns.filter((column) => column !== 'person')

                columns = (['first_name', 'last_name', 'email', 'phone']).concat(columns)
            }

            try {
                const params = {
                    ...this.selectDate,
                    orderBy: this.orderBy,
                    columns,
                    filters: {
                        ...this.filter
                    }
                }

                if(this.non_ftd) {
                    params.filters.non_ftd = this.non_ftd
                }

                if(!params.orderBy.direction) {
                    params.orderBy = {'name':'id', 'direction':'desc'}
                }

                const response = await send(this.$url.recycle.sent_csv, 'GET', { params })

                download(response.data, `recycle-sent-leads-${  (new Date()).getTime()}`, 'text/csv')
            } catch (e) {
                new ErrorHandler(e).send
            }
        },

        clearQueue() {
            if (!this.selectAll) {
                this.selectAll = true
            } else {
                this.$vs.dialog({
                    type: 'confirm',
                    color: 'warning',
                    title: this.$t('confirm.Confirm_action'),
                    text: this.$t('confirm.clearQueue'),
                    accept: async () => {
                        try {
                            await send(this.$url.recycle.pending, 'DELETE', {data: {ids: this.selectIds}})
                            await this.get(false, true)

                            this.$refs.table.clearSelect()
                            this.selectAll = false
                        } catch (e) {
                            new ErrorHandler(e).send
                        }
                    },
                    acceptText: this.$t('buttons.Clear'),
                    cancelText: this.$t('global.Cancel')
                })
            }
        },

        clearQueueClose() {
            this.selectIds = []
            this.$refs.table.clearSelect()
            this.selectAll = false
        },

        async clearErrors() {
            this.$vs.dialog({
                type: 'confirm',
                color: 'warning',
                title: this.$t('confirm.Confirm_action'),
                text: this.$t('confirm.clearErrors'),
                accept: async () => {
                    try {
                        await send(this.$url.recycle.failed, 'DELETE')
                        await this.get(false, true)
                    } catch (e) {
                        new ErrorHandler(e).send
                    }
                },
                acceptText: this.$t('buttons.Clear'),
                cancelText: this.$t('global.Cancel')
            })
        },

        async fixDeposit(id) {
            try {
                await send(this.$url.recycle.fix_lead, 'POST', {data: {lead_id: id}})

                const index = this.leads.findIndex(item => item.id === id)

                const lead_id = this.leads[index].lead_id

                this.leads = this.leads.map(item => {
                    if (item.lead_id === lead_id) item.is_fixed_lead = true
                    return item
                })
            } catch (e) {
                new ErrorHandler(e).send
            }
        },

        createFields() {
            const fields = this.copyData(this.fields)

            const footer = fields.filter(item => item.footer)
            const exclude = footer.map(item => item.field)

            this.fields = {
                fields: fields.filter(item => !exclude.includes(item.field)),
                footer: footer
            }
        },

        recycleAction() {
            const selected = Object.entries(this.copyData(this.filter))
                .reduce((res, [key, val]) => {
                    if (this.selectedRequiredData.includes(key))
                        res[this.selectedRequiredDataTransform[key]] = val[0]

                    return res
                }, {})

            const data = {
                selected,
                total: this.totalNum,
                date: this.selectDate,
                filters: {...this.filter, non_ftd: this.non_ftd}
            }

            if (!data.filters.non_ftd) {
                delete data.filters.non_ftd
            }

            EventBus.$emit('emitPopupEvent', {
                type: 'recycle',
                name: this.$t('modals.Recycle'),
                full: true,
                data
            })
        },

        copyData(data) {
            return JSON.parse(JSON.stringify(data))
        },

        copy(data) {
            copy(data)
            const icon = this.$iconData('icon-check', 'fi-rr-check')
            this.$vs.notify({
                title: 'Success!',
                text: this.$t('notification.success'),
                color: 'success',
                iconPack: icon['icon-pack'],
                icon: icon.icon
            })
        },

        async page(page, filter = false) {
            if (this.pageNum !== page) {
                this.pageNum = page
                await this.get(filter, true)
            }
        },

        async limit(limit) {
            if (limit !== this.limitNum) {
                this.limitNum = limit

                if (this.pageNum !== 1) {
                    await this.page(1)
                } else {
                    await this.get(false)
                }
            }
        },

        async sort(sort) {
            this.orderBy =  {
                name: sort.name,
                direction: sort.type
            }

            await this.get(false)
        },

        async view(data) {
            try {
                data.display = !data.display

                const display = this.heads.reduce((res, acc) => {
                    res[acc.value] = acc.display
                    return res
                }, {})

                await send(this.$url.user['change-fields'], 'PUT', {
                    data: {fields: JSON.stringify(display)}
                })

                this.$store.commit('SET_USER_FIELDS', {
                    event: data.value,
                    display: data.display
                })
            } catch (e) {
                new ErrorHandler(e).send
            }
        },

        async refreshTable() {
            await this.get(true, true)
        },

        resetDate(direction) {
            Object.keys(this.date).map(key => {
                if (direction !== key) {
                    this.date[key].startDate = new Date()
                    this.date[key].endDate = new Date()
                }
            })
        },

        selectedDate(date) {
            this.resetDate('created_at')
            this.resetDate('send_date')
            this.resetDate('first_action_date')

            this.date[date.direction].startDate = date.startDate
            this.date[date.direction].endDate = date.endDate

            this.selectDateSystem = {
                direction: date.direction,
                start: this.dateParse(date.startDate),
                end: this.dateParse(date.endDate)
            }
        },

        async getHistoryStatuses(data) {
            try {
                const params = {
                    id: data.id
                }

                const leadHistoryStatuses = await send(this.$url.statistic.get_lead_history_statuses, 'GET', {params})
                    .then(data => data.data.result.lead_history_statuses)

                EventBus.$emit('emitPopupEvent', {
                    type: 'leadHistoryStatuses',
                    name: this.$t('modals.Lead_history_statuses'),
                    ids: leadHistoryStatuses
                })
            } catch (e) {
                new ErrorHandler(e).send
            }
        },

        getGeoFlag(geo) {
            return getLanguages(geo)
        },

        statusColor(status) {
            const template = {
                hold: '#FF9F43',
                sended: '#28C76F',
                not_valid: '#CCCCCC',
                trash: '#EA5455',
                duplicate: '#CCCCCC'
            }

            return template[status] ? template[status] : '#CCCCCC'
        },

        createName(name) {
            if (name) {
                const str = name.split('_').join(' ')
                return str[0].toUpperCase() + str.slice(1)
            } else {
                return '-'
            }
        },

        async selectedTab(index) {
            const {event} = this.statusList[index]

            this.status = event

            this.orderBy = {"name":"id","direction":"desc"}

            if (this.pageNum === 1) {
                await this.get(true)
            } else {
                await this.page(1, true)
            }

            this.activeTab = index
            this.statusSystem = event
        },

        async submitFilter(data) {
            this.filter = this.copyData(data)
            this.selectDate = this.selectDateSystem

            Object.keys(this.filter).map(key => {
                if (Array.isArray(this.filter[key])) {
                    this.filter[key] = this.filter[key].map(item => {
                        if (/^[-]$/.test(item))
                            item = null
                        return item
                    })
                } else {
                    if (/^[-]$/.test(this.filter[key]))
                        this.filter[key] = null
                }

                if (!Array.isArray(this.filter[key])) {
                    this.filter[key] = [this.filter[key]]
                }
            })

            if (this.pageNum !== 1) {
                await this.page(1, true)
            } else {
                await this.get()
            }

            const list = this.selectedRequiredData.reduce((res, key) => {
                const item = Object.keys(this.filter).find(item => item === key)
                if (item) res.push(item)

                return res
            }, [])

            this.recycleDisabled = list.length !== 3;
        },

        async refreshFilter() {
            this.resetDate()
            this.selectedDate({
                ...this.date.send_date,
                direction: 'send_date'
            })

            this.selectDate = this.selectDateSystem

            this.filter = {}
            this.non_ftd = false
            this.recycleDisabled = true

            await this.get()
        },

        guaranteeLocale(guarantee, start = false) {
            const temp = {
                guarantee: this.$t('global.guarantee'),
                no_guarantee: this.$t('global.no_guarantee')
            }

            if (!start) {
                return guarantee.map(item => {
                    if (item.id === '0') {
                        item.name = temp.no_guarantee
                    } else {
                        item.name = temp.guarantee
                    }
                    return item
                })
            }

            return [
                {name: temp.no_guarantee, id: '0'},
                {name: temp.guarantee, id: '1'}
            ]
        },

        landingUrl(str) {
            if (!str) return str

            return str.replace(/^https?:\/\//, '')
                .replace(/[\/?].*/, '')
                .replace(/^https?%3A%2F%2F/, '')
                .replace(/((%2F)|(%3F)).*/, '')
        },

        replaceNullToString(data) {
            Object.entries(data).map(([key, value]) => {
                data[key] = value.map(item => item === null ? '-' : item)
            })

            return data
        },

        domainMutation(data) {
            return data ? data.map(item => this.landingUrl(item)) : []
        },

        affiliateMutation(data) {
            const affiliates = data.team_id.reduce((res, acc) => {
                res.push(...acc.affiliate_id)
                return res
            }, [])

            data.affiliate_id = data.affiliate_id.reduce((res, acc) => {
                const aff = affiliates.find(item => item.id === acc)
                if (aff) res.push(aff)
                return res
            }, [])

            return data.affiliate_id
        },

        integrationMutation(data) {
            if (data.advertiser_integration_id) {
                return data.advertiser_integration_id.map(item => {
                    const advertiser = data.advertiser_id.find(advertiser => advertiser.id === item.advertiser_id)

                    if (advertiser) {
                        item.name = `${item.name}/${advertiser.name || advertiser.id}`
                    }

                    return item
                })
            } else {
                return []
            }
        },

        createTabs(count) {
            let list = [
                'leads',
                'pending',
                'sent',
                'failed'
            ]

            return list.map(name => ({
                name: `leadCount.${name}`,
                count: count[name],
                event: name
            }))
        },

        parseJSON(data) {
            try {
                return JSON.parse(data)
            } catch (e) {
                return data
            }
        },

        isObject(element) {
            return typeof element === 'object' && element !== null && !Array.isArray(element)
        },

        async getLeads(path, params = {}) {
            try {
                const response = await send(path, 'GET', {params})
                    .then(response => response.data.result)

                return response
            } catch (e) {
                new ErrorHandler(e).send
            }
        },

        async getCount(path, params = {}) {
            try {
                const obj = {...params}

                delete obj.limit
                delete obj.page
                delete obj.orderBy

                const response = await send(path, 'GET', {params: obj})
                    .then(response => response.data.result)

                return response
            } catch (e) {
                new ErrorHandler(e).send
            }
        },

        async getFilter(path, params = {}) {
            try {
                const exclude = [
                    'send_date',
                    'created_at',
                    'first_action_date',
                    'email',
                    'phone',
                    'id',
                    'guarantee',
                    'lead_id'
                ]

                if (!this.isAdv) {
                    exclude.push(...[
                        'advertiser_id',
                        'advertiser_integration_id'
                    ])
                }

                let obj = {...params}

                delete obj.limit
                delete obj.page
                delete obj.orderBy

                const list = (this.fields.footer ? [...this.fields.footer, ...this.fields.fields] : this.fields)
                    .map(item => item.field)
                    .filter(name => !exclude.includes(name))

                const response = await Promise.all(list.map(key => {
                    obj = {...obj, filter: key}
                    return send(path, 'GET', {params: obj})
                        .then(response => response.data.result)
                }))

                return response
            } catch (e) {
                new ErrorHandler(e).send
            }
        },

        showByStatus(status) {
            const heads = this.copyData(this.headsSystem)

            const templateHide = {
                leads: ['lead_id'],
                pending: ['guarantee'],
                sent: ['guarantee'],
                failed: ['guarantee']
            }

            if (templateHide[status]) {
                return heads.filter(head => !templateHide[status].includes(head.value) && this.isPermission(head.can))
            } else {
                return heads
            }
        },

        async get(required_filter = true, count = false) {
            try {
                this.loader = true
                const statusTemplate = this.templateSendTab[this.status]

                const params = {
                    ...this.selectDate,
                    limit: this.limitNum,
                    page: this.pageNum,
                    status: this.status,
                    orderBy: this.orderBy,
                    filters: {
                        ...this.filter
                    }
                }

                if (this.non_ftd) {
                    params.filters.non_ftd = this.non_ftd
                }

                if (!params.orderBy.direction) {
                    params.orderBy = {"name":"id","direction":"desc"}
                }

                if (this.status !== 'sent') {
                    delete params.filters.lead_id
                }

                (this.fields.fields || this.fields)[2].display = this.status === 'sent'

                const request = [
                    this.getLeads(statusTemplate.path, params)
                ]

                if (required_filter && statusTemplate.filter) {
                    request.push(
                        this.getCount(this.$url.recycle.count, params),
                        this.getFilter(statusTemplate.filter, params)
                    )
                }

                if (count) {
                    request.push(
                        this.getCount(this.$url.recycle.count, params)
                    )
                }

                const response = await Promise.all(request)

                const leads = response[0].leads

                if (count) {
                    this.count = response[1].count
                }

                if (required_filter && statusTemplate.filter) {
                    this.count = response[1].count
                    let filters = response[2].reduce((res, acc) => Object.assign(res, acc.filters), {})

                    filters = this.replaceNullToString(filters)
                    filters.domain = this.domainMutation(filters.domain)
                    filters.affiliate_id = this.affiliateMutation(filters)
                    filters.advertiser_integration_id = this.integrationMutation(filters)
                    filters.guarantee = leads.length ? this.guaranteeLocale(filters.guarantee, true) : []

                    this.heads = this.headsSystem

                    if (this.userState.lead_statistic_fields) {
                        const display = this.parseJSON(this.userState.lead_statistic_fields)

                        this.heads.forEach(head => {
                            if (display.hasOwnProperty(head.value)) head.display = display[head.value]
                            return head
                        })
                    }

                    this.filtersData = filters
                }

                if (this.status === 'leads') {
                    this.heads = this.heads.filter(item => item.value !== 'lead_id')
                }

                this.statusList = this.createTabs(this.count)
                const status = this.statusList
                    .find(item => item.event === params.status)

                this.heads = this.showByStatus(status.event)

                this.totalNum = status.count

                this.filterDisabled = !statusTemplate.filter

                this.leads = leads
            } catch (e) {
                new ErrorHandler(e).send
            } finally {
                this.loader = false
            }
        }
    },

    async mounted() {
        await this.get()

        if (!this.isAdv) {
            const template = [
                'advertiser_id',
                'advertiser_integration_id'
            ]

            this.fields = this.fields.filter(filter => !template.includes(filter.field))
            this.heads = this.heads.filter(head => !template.includes(head.value))
        }

        if (!(this.userState.team.is_internal || this.userState.group === 2)) {
            this.heads = this.heads.filter(item => item.value !== 'a_history')
        }

        this.createFields()

        if (!this.isPermission('settings_team.show_team_name')) {
            const index = this.fields.fields.findIndex(item => item.field === 'team_id')
            this.$set(this.fields.fields[index], 'sоrtKey', 'id')
        }

        if (!this.isPermission('settings_advertiser.show_advertiser_name')) {
            const index = this.fields.fields.findIndex(item => item.field === 'advertiser_id')
            this.$set(this.fields.fields[index], 'sоrtKey', 'id')
        }

        this.isMounted = true

        EventBus.$on('updateLeads', (lead) => {
            this.leads = this.leads.map(item => {
                return lead.id === item.id ? {
                    ...lead,
                    landing_url_sp: lead.landing_url ? lead.landing_url.split('/')[0] : null
                } : item
            })
        })

        EventBus.$on('updateCount', async () => {
            try {
                const params = {
                    ...this.selectDate,
                    limit: this.limitNum,
                    page: this.pageNum,
                    status: this.status,
                    orderBy: this.orderBy,
                    filters: {...this.filter},
                    non_ftd: this.non_ftd
                }

                const count = await this.getCount(this.$url.recycle.count, params)
                this.statusList = this.createTabs(count.count)

                const status = this.statusList
                    .find(item => item.event === params.status)

                this.totalNum = status.count
            } catch (e) {
                new ErrorHandler(e).send
            }
        })
    },

    destroyed() {
        EventBus.$off('updateLeads')
        EventBus.$off('updateCount')
    }
}
</script>

<style lang="scss">
.statusErrorsText {
    max-width: 250px;
    text-overflow: ellipsis;
    overflow: hidden;
}

.vs-dropdown--custom {
    max-height: 400px;
    overflow-y: auto;
    height: 100%;

    &::-webkit-scrollbar {
        width: 5px;
    }

    &::-webkit-scrollbar-track {
        background: white;
    }

    &::-webkit-scrollbar-thumb {
        background: #cdcdcd;
    }

    &::-webkit-scrollbar-thumb:hover {
        background: #b3b3b3;
    }
}
</style>
